/* eslint-disable react-hooks/rules-of-hooks */
import requester from '@/utils/requester';
import { message } from 'antd';
import { isArray } from 'lodash';
import { StateCreator, create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface IMobileGlobalState {
  tags?: any;
  emrTypes?: Record<string, IEMRType>;
  phrConfigs?: IPhrMobileConfig;
  errorMessage?: string;
  isLoading?: boolean;
  getListCreateEMRs: () => IEMRType[];
  getConfigs: () => void;
  getEmrType: (codeEmrType: string) => IEMRType;
}

const initState = {
  tags: undefined,
  emrTypes: undefined,
  phrConfigs: undefined,
  errorMessage: undefined,
};
const getSub = (emrType: IEMRType, emrTypes: Record<string, IEMRType>) => {
  emrType.fields = {};
  emrType.extra = { ...Function(emrType.extraFunction)() };

  emrType.format.fields.map((f: IFieldConfig, i: number) => {
    f.index = i;
    f.extra = { ...Function(f.extraFunction)(), ...f.extra };

    if (emrTypes[f.emrType]) {
      f.emr = JSON.parse(JSON.stringify(emrTypes[f.emrType]));

      const listFieldRaw = [...f.emr.format.fields];

      const objCustomFields = f.extra?.fields?.reduce((d: any, e: any) => {
        if (typeof e === 'string') {
          d[e] = { key: e };
        } else {
          d[e.key] = e;
        }
        return d;
      }, {});

      f.emr.format.fields = f.extra?.fields?.length
        ? listFieldRaw.filter((f) => {
            if (objCustomFields[f?.key]) {
              // ưu tiên merge extra
              if (objCustomFields[f.key]?.extra && typeof objCustomFields[f.key]?.extra === 'object') {
                f.extra = f.extra || {};
                Object.assign(f?.extra, objCustomFields[f.key]?.extra);
              }
              // sau đó merge các config
              Object.assign(f, objCustomFields[f.key]);
            }
            return Object.keys(objCustomFields)?.includes(f.key);
          })
        : listFieldRaw;

      //   if (emrType.code === 'hearthRate') console.log(emrType.format);

      if (f.emr) getSub(f.emr, emrTypes);
    }
  });
};

const useGlobalMobileConfigs = create<IMobileGlobalState>(
  devtools(
    persist(
      (set, get) => {
        return {
          ...initState,

          async getConfigs() {
            try {
              // Lấy danh sách emrType
              const emrTypeResponse = await requester.get(`/phr/v1/emr-types`, { params: { limit: 10e3 } });
              const configs: Record<string, IEMRType> = emrTypeResponse?.data?.reduce(
                (data: any, element: IEMRType) => {
                  element.extra = { ...Function(element.extraFunction)(), ...element.extra };
                  data[element.code] = element;
                  return data;
                },
                {},
              );
              if (!configs) {
                //   this.getConfigs();
              } else {
                Object.values(configs).forEach((emrType) => getSub(emrType, configs));
                window.emrTypes = configs;

                // Lấy danh sách tag
                const tagResponse = await requester.get(`/phr/v1/emrs/tag`);
                let listTags = {};
                if (isArray(tagResponse?.data)) {
                  listTags = tagResponse.data.reduce((data: any, element: any) => {
                    data[element?._id] = element;
                    return data;
                  }, {});
                }

                // Lấy phrConfigs
                const configsResponse = await requester.get(`/center/v1/configs?key=phr_config`);
                const phrConfigs: any = configsResponse?.data?.value
                  ? Function(configsResponse?.data?.value)()
                  : undefined;

                const { createEMRs, mobile: phrConfigsMobile } = phrConfigs;
                
                set((state) => ({
                  ...state,
                  emrTypes: configs,
                  phrConfigs: { ...phrConfigsMobile, createEMRs },
                  tags: listTags,
                }));
              }
            } catch (error: any) {
              message.error(error.message);
            }
          },
          getEmrType(codeEmrType: string) {
            return get().emrTypes?.[codeEmrType] as IEMRType;
          },
          getListCreateEMRs() {
            const keys = get().phrConfigs?.createEMRs;
            const emrTypes = get().emrTypes;
            const result = keys?.map((k) => emrTypes?.[k]).filter(Boolean) as IEMRType[];
            return result;
          },
        };
      },
      {
        name: 'global-configs-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    { name: 'global-configs' },
  ) as StateCreator<IMobileGlobalState>,
);

export default useGlobalMobileConfigs;
